import { render, staticRenderFns } from "./UserDataPermissionDialog.vue?vue&type=template&id=1ec2a3ac&scoped=true&"
import script from "./UserDataPermissionDialog.vue?vue&type=script&lang=js&"
export * from "./UserDataPermissionDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserDataPermissionDialog.vue?vue&type=style&index=0&id=1ec2a3ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2a3ac",
  null
  
)

export default component.exports